var map = {
	"./flame.png": 8568,
	"./scene-overlay-frost.png": 60,
	"./stars.png": 3108,
	"game-files/animations/src/flame.png": 8568,
	"game-files/animations/src/scene-overlay-frost.png": 60,
	"game-files/animations/src/stars.png": 3108
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9957;